import * as tslib_1 from "tslib";
import { initializeFeature } from 'owa-feature-flags';
import { initialize as initializeDefaultSettingsExperiment } from 'owa-mail-defaultsettings';
import { initializeFocusedInboxConfig } from 'owa-mail-focused-inbox-config';
import { loadFolderForest } from 'owa-mail-folder-forest-actions';
import { reloadInboxPostBoot } from 'owa-mail-list-actions';
import { initializeTablesInCache } from 'owa-mail-list-actions/lib/actions/helpers/tableCache/updateTablesInCache';
import { setShowFolderPane } from 'owa-mail-module-actions';
import { initializeShowReadingPane } from 'owa-mail-module-orchestrator';
import { getMoveToMruList } from 'owa-mail-move-mru';
import { performDateTimeChangeTasks } from 'owa-mail-store-actions';
import FolderPaneExpansionSource from 'owa-mail-store/lib/store/schema/FolderPaneExpansionSource';
import { lazyInitializeUpNext } from 'owa-upnext';
import { action } from 'satcheljs/lib/legacy';
export default action('initializeMailModuleState')(function initializeMailModuleState() {
    var _this = this;
    initializeDefaultSettingsExperiment();
    performDateTimeChangeTasks();
    initializeTablesInCache();
    loadFolderForest();
    initializeShowReadingPane();
    initializeFocusedInboxConfig();
    setShowFolderPane(FolderPaneExpansionSource.Init);
    getMoveToMruList();
    reloadInboxPostBoot();
    initializeFeature('tri-upNext', function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var initializeUpNext;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyInitializeUpNext.import()];
                case 1:
                    initializeUpNext = _a.sent();
                    initializeUpNext();
                    return [2 /*return*/];
            }
        });
    }); });
});
//# sourceMappingURL=initializeMailModuleState.js.map